/* About.js */

import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import Strings from '../../translations/Translations';
import { Link } from 'react-router-dom';
// import AppBar1 from '../../components/commom/AppBar1';
import Footer1 from '../../components/commom/Footer1';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';

const APP_VERSION = process.env.REACT_APP_VERSION;
const APP_BUILD = process.env.REACT_APP_BUILD;

export default function About() {
  return (
    <>
      <AppBar2 />

      <div className='min-height-100vh'>
        <Container fluid className='py-4'>
          <Row>
            <Col md={8} className='d-flex align-items-center'>
              <h1 className='h3'>{Strings('about')}</h1>
            </Col>
            <Col md={4} className='d-flex justify-content-end align-items-center'>
              <Link to='dashboard' className='btn btn-secondary btn-lg mr-10px'>
                {Strings('my_music_videos')}
              </Link>
              <Link to='create' className='btn btn-primary btn-lg pb-btn-1'>
                {Strings('create_music_video')}
              </Link>
            </Col>
          </Row>

          <Row className='mt-5'>
            <Col>
              <p>{Strings('application_title')}</p>
              <p>Version: {APP_VERSION}</p>
              <p>Build: {APP_BUILD}</p>
            </Col>
          </Row>

        </Container>
      </div>

      <Footer1 />
    </>
  );
}
